import { render, staticRenderFns } from "./CompanyConcepts.vue?vue&type=template&id=af486346&scoped=true&"
import script from "./CompanyConcepts.vue?vue&type=script&lang=js&"
export * from "./CompanyConcepts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af486346",
  null
  
)

export default component.exports